'use strict';

import _ from 'lodash';

import {PropertyValueType} from '~/shared/src/mm/PropertySet';
import {
    fieldTypeToItemTypeMapping,
    FormFieldProperties,
    valueTypeToFieldTypeMapping,
    VariableFieldProperties
} from '~/shared/src/utilities/modules/form';

import {
    componentProps as booleanFieldComponentProps,
    ComponentProps as BooleanFieldComponentProps
} from '~/frontend/src/components/base/shared/field/valueTypeFields/BooleanField';
import {
    componentProps as buttonFieldComponentProps,
    ComponentProps as ButtonFieldComponentProps
} from '~/frontend/src/components/base/shared/field/ButtonField';
import {
    componentProps as calendarViewComponentProps,
    ComponentProps as CalendarViewComponentProps
} from '~/frontend/src/components/base/shared/view/CalendarView';
import {
    componentProps as chartViewComponentProps,
    ComponentProps as ChartViewComponentProps
} from '~/frontend/src/components/base/shared/view/ChartView';
import {
    componentProps as colorFieldComponentProps,
    ComponentProps as ColorFieldComponentProps
} from '~/frontend/src/components/base/shared/field/valueTypeFields/ColorField';
import {
    componentProps as coordinateFieldComponentProps,
    ComponentProps as CoordinateFieldComponentProps
} from '~/frontend/src/components/base/shared/field/valueTypeFields/CoordinateField';
import {
    componentProps as currencyFieldComponentProps,
    ComponentProps as CurrencyFieldComponentProps
} from '~/frontend/src/components/base/shared/field/valueTypeFields/CurrencyField';
import {
    componentProps as dateFieldComponentProps,
    ComponentProps as DateFieldComponentProps
} from '~/frontend/src/components/base/shared/field/valueTypeFields/DateField';
import {
    componentProps as doubleFieldComponentProps,
    ComponentProps as DoubleFieldComponentProps
} from '~/frontend/src/components/base/shared/field/valueTypeFields/DoubleField';
import {
    componentProps as durationFieldComponentProps,
    ComponentProps as DurationFieldComponentProps
} from '~/frontend/src/components/base/shared/field/valueTypeFields/DurationField';
import {
    componentProps as emailFieldComponentProps,
    ComponentProps as EmailFieldComponentProps
} from '~/frontend/src/components/base/shared/field/valueTypeFields/EmailField';
import {
    componentProps as graphViewComponentProps,
    ComponentProps as GraphViewComponentProps
} from '~/frontend/src/components/base/shared/view/GraphView';
import {
    componentProps as ibanFieldComponentProps,
    ComponentProps as IbanFieldComponentProps
} from '~/frontend/src/components/base/shared/field/valueTypeFields/IbanField';
import {
    componentProps as imageDataFieldComponentProps,
    ComponentProps as ImageDataFieldComponentProps
} from '~/frontend/src/components/base/shared/field/valueTypeFields/ImageDataField';
import {
    componentProps as integerFieldComponentProps,
    ComponentProps as IntegerFieldComponentProps
} from '~/frontend/src/components/base/shared/field/valueTypeFields/IntegerField';
import {
    componentProps as jsonFieldComponentProps,
    ComponentProps as JsonFieldComponentProps
} from '~/frontend/src/components/base/shared/field/valueTypeFields/JsonField';
import {
    componentProps as linkFieldComponentProps,
    ComponentProps as LinkFieldComponentProps
} from '~/frontend/src/components/base/shared/field/valueTypeFields/LinkField';
import {
    componentProps as mapViewComponentProps,
    ComponentProps as MapViewComponentProps
} from '~/frontend/src/components/base/shared/view/MapView';
import {
    componentProps as overviewViewComponentProps,
    ComponentProps as OverviewViewComponentProps
} from '~/frontend/src/components/base/shared/view/OverviewView';
import {
    componentProps as passwordFieldComponentProps,
    ComponentProps as PasswordFieldComponentProps
} from '~/frontend/src/components/base/shared/field/PasswordField';
import {
    componentProps as phoneFieldComponentProps,
    ComponentProps as PhoneFieldComponentProps
} from '~/frontend/src/components/base/shared/field/valueTypeFields/PhoneField';
import {
    componentProps as staticContentFieldComponentProps,
    ComponentProps as StaticContentFieldComponentProps
} from '~/frontend/src/components/base/shared/field/StaticContentField';
import {
    componentProps as stringFieldComponentProps,
    ComponentProps as StringFieldComponentProps
} from '~/frontend/src/components/base/shared/field/valueTypeFields/StringField';
import {
    componentProps as textFieldComponentProps,
    ComponentProps as TextFieldComponentProps
} from '~/frontend/src/components/base/shared/field/valueTypeFields/TextField';
import {
    componentProps as timeFieldComponentProps,
    ComponentProps as TimeFieldComponentProps
} from '~/frontend/src/components/base/shared/field/valueTypeFields/TimeField';
import {
    componentProps as timestampFieldComponentProps,
    ComponentProps as TimestampFieldComponentProps
} from '~/frontend/src/components/base/shared/field/valueTypeFields/TimestampField';
import {
    componentProps as valueSetFieldComponentProps,
    ComponentProps as ValueSetFieldComponentProps
} from '~/frontend/src/components/base/shared/field/ValueSetField';

export const fieldUtils = {

    extractPropsForValueTypeFields( props : FormFieldProperties | VariableFieldProperties ) : any | undefined {
        const fieldType = props.type === 'VARIABLE' ? props.variableType : props.type;

        let retVal : any | undefined;

        switch ( fieldType ) {
            case 'CALENDAR':
                retVal = _.pick( props, [ 'key' ].concat( calendarViewComponentProps ) ) as CalendarViewComponentProps;
                break;

            case 'CHART':
                retVal = _.pick( props, [ 'key' ].concat( chartViewComponentProps ) ) as ChartViewComponentProps;
                break;

            case 'GRAPH':
                retVal = _.pick( props, [ 'key' ].concat( graphViewComponentProps ) ) as GraphViewComponentProps;
                break;

            case 'MAP':
                retVal = _.pick( props, [ 'key' ].concat( mapViewComponentProps ) ) as MapViewComponentProps;
                break;

            case 'OVERVIEW':
                retVal = _.pick( props, [ 'key' ].concat( overviewViewComponentProps ) ) as OverviewViewComponentProps;
                break;

            case 'BOOLEAN':
                retVal = _.pick( props, [ 'key' ].concat( booleanFieldComponentProps ) ) as BooleanFieldComponentProps;
                break;

            case 'BUTTON':
                retVal = _.pick( props, [ 'key' ].concat( buttonFieldComponentProps ) ) as ButtonFieldComponentProps;
                break;

            case 'COLOR':
                retVal = _.pick( props, [ 'key' ].concat( colorFieldComponentProps ) ) as ColorFieldComponentProps;
                break;

            case 'COORDINATE':
                retVal = _.pick( props, [ 'key' ].concat( coordinateFieldComponentProps ) ) as CoordinateFieldComponentProps;
                break;

            case 'CURRENCY':
                retVal = _.pick( props, [ 'key' ].concat( currencyFieldComponentProps ) ) as CurrencyFieldComponentProps;
                break;

            case 'DATE':
                retVal = _.pick( props, [ 'key' ].concat( dateFieldComponentProps ) ) as DateFieldComponentProps;
                break;

            case 'DOUBLE':
                retVal = _.pick( props, [ 'key' ].concat( doubleFieldComponentProps ) ) as DoubleFieldComponentProps;
                break;

            case 'DURATION':
                retVal = _.pick( props, [ 'key' ].concat( durationFieldComponentProps ) ) as DurationFieldComponentProps;
                break;

            case 'EMAIL':
                retVal = _.pick( props, [ 'key' ].concat( emailFieldComponentProps ) ) as EmailFieldComponentProps;
                break;

            case 'IBAN':
                retVal = _.pick( props, [ 'key' ].concat( ibanFieldComponentProps ) ) as IbanFieldComponentProps;
                break;

            case 'IMAGEDATA':
                retVal = _.pick( props, [ 'key' ].concat( imageDataFieldComponentProps ) ) as ImageDataFieldComponentProps;
                break;

            case 'INTEGER':
                retVal = _.pick( props, [ 'key' ].concat( integerFieldComponentProps ) ) as IntegerFieldComponentProps;
                break;

            case 'JSON':
                retVal = _.pick( props, [ 'key' ].concat( jsonFieldComponentProps ) ) as JsonFieldComponentProps;
                break;

            case 'LINK':
                retVal = _.pick( props, [ 'key' ].concat( linkFieldComponentProps ) ) as LinkFieldComponentProps;
                break;

            case 'PASSWORD':
                retVal = _.pick( props, [ 'key' ].concat( passwordFieldComponentProps ) ) as PasswordFieldComponentProps;
                break;

            case 'PHONE':
                retVal = _.pick( props, [ 'key' ].concat( phoneFieldComponentProps ) ) as PhoneFieldComponentProps;
                break;

            case 'STATIC':
                retVal = _.pick( props, [ 'key' ].concat( staticContentFieldComponentProps ) ) as StaticContentFieldComponentProps;
                break;

            case 'STRING':
                retVal = _.pick( props, [ 'key' ].concat( stringFieldComponentProps ) ) as StringFieldComponentProps;
                break;

            case 'TEXT':
                retVal = _.pick( props, [ 'key' ].concat( textFieldComponentProps ) ) as TextFieldComponentProps;
                break;

            case 'TIME':
                retVal = _.pick( props, [ 'key' ].concat( timeFieldComponentProps ) ) as TimeFieldComponentProps;
                break;

            case 'TIMESTAMP':
                retVal = _.pick( props, [ 'key' ].concat( timestampFieldComponentProps ) ) as TimestampFieldComponentProps;
                break;

            case 'VALUESET':
                retVal = _.pick( props, [ 'key' ].concat( valueSetFieldComponentProps ) ) as ValueSetFieldComponentProps;
                break;
        }

        return retVal;
    },

    checkValueTypeForFieldType( valueType : PropertyValueType, fieldType : FormFieldProperties['type'] ) : boolean {
        return valueTypeToFieldTypeMapping[ valueType ].includes( fieldType );
    },

    getAllowedFieldTypesForValueType( valueType : PropertyValueType ) : string[] | undefined {
        return valueTypeToFieldTypeMapping[ valueType ]?.map( fieldType => fieldTypeToItemTypeMapping[ fieldType ] ).sort();
    }
};
